import {IRange} from "@pg-design/inputs-module";

export const hasAreaValidationError = (value: IRange<string>) => {
    const lowerValue = parseFloat(value.lower);
    const upperValue = parseFloat(value.upper);

    return !isNaN(lowerValue) && !isNaN(upperValue) && lowerValue > upperValue;
};

export const errorMessages = {
    area: ["Wpisz poprawne wartości", "Błędny przedział OD - DO"]
};
import {IRange} from "@pg-design/inputs-module";

export const hasAreaValidationError = (value: IRange<string>) => {
    const lowerValue = parseFloat(value.lower);
    const upperValue = parseFloat(value.upper);

    return !isNaN(lowerValue) && !isNaN(upperValue) && lowerValue > upperValue;
};

export const errorMessages = {
    area: ["Wpisz poprawne wartości", "Błędny przedział OD - DO"]
};
